export const mealPlanVoucherGroupID = [
  "62f7eaec02eb6d5f4365ed55",
  "62f7ebca02eb6d5f4365f142"
]

export const mealPlanVoucherGroupIDSandbox = [
  "62f77509793f934bdab8be7a"
]
  
